import {
    URLAPI,
    WORK_SHEETS_PATH,
    WORK_SHEET_CREATE_PATH,
    WORK_SHEET_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_work_sheets: {
        data: [],
        status: 0,
        message: {},
    },
    _create_work_sheet: {
        data: {},
        status: 0,
        message: {},
    },
    _update_work_sheet: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_WORK_SHEETS = "GET_ALL_WORK_SHEETS";
export const CREATE_WORK_SHEET = "CREATE_WORK_SHEET";
export const UPDATE_WORK_SHEET = "UPDATE_WORK_SHEET";

export const work_sheets_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_WORK_SHEETS:
            return {
                ...state,
                _get_all_work_sheets: action.payload,
            };
        case CREATE_WORK_SHEET:
            return {
                ...state,
                _create_work_sheet: action.payload,
            };
        case UPDATE_WORK_SHEET:
            return {
                ...state,
                _update_work_sheet: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllWorkSheets = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${WORK_SHEETS_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_WORK_SHEETS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_WORK_SHEETS,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_WORK_SHEETS,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createWorkSheet = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${WORK_SHEET_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_SHEET,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_SHEET,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_SHEET,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateWorkSheet = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${WORK_SHEET_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_WORK_SHEET,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_WORK_SHEET,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_WORK_SHEET,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_work_sheet = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
